import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button4", component(opts));
  editor.BlockManager.add("button4", block(opts));
};